var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-table",
    { attrs: { data: _vm.items } },
    [
      _c("el-table-column", { attrs: { prop: "name", label: "Name" } }),
      _vm._v(" "),
      _c("el-table-column", {
        attrs: { prop: "value", label: "Value" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({ row: { value, name } }) {
              return [
                _c("table-input", {
                  attrs: { value: value, name: name, scope: _vm.scope },
                  on: { input: _vm.onInput },
                }),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }